import { Button } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import { PiArrowsClockwise, PiPaperPlaneTilt } from 'react-icons/pi';
import { useSendEmail } from 'services/email/email';
import { DOCUMENT_TYPE } from 'services/email/types';
import { EMAIL_SEND } from 'services/types';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

interface ISendButtonEmailProps {
  documentId: string;
  documentType: DOCUMENT_TYPE;
  refetch?: () => void;
  status?: EMAIL_SEND;
}

const SendButtonEmail = ({
  documentId,
  refetch,
  documentType,
  status,
}: ISendButtonEmailProps) => {
  const sendEmail = useSendEmail();
  const { t } = useTranslation();
  const showSendLabel = status === EMAIL_SEND.notSend;

  return (
    <Button
      type='button'
      onlyIcon={!showSendLabel}
      isClear
      disabled={
        sendEmail.isPending && sendEmail.variables.documentId === documentId
      }
      isLoading={
        sendEmail.isPending && sendEmail.variables.documentId === documentId
      }
      onClick={async () =>
        await sendEmail.mutateAsync(
          {
            documentId: documentId,
            documentType: documentType,
          },
          {
            onSuccess: refetch,
            onError: error => onErrorShowAllErrorsToast(error),
          }
        )
      }>
      {!showSendLabel && (
        <Button.Description description={t('button.refresh')} />
      )}
      {showSendLabel ? (
        <>
          <Button.Text text={t('button.send-email')} />
          <Button.Icon icon={<PiPaperPlaneTilt />} />
        </>
      ) : (
        <Button.Icon icon={<PiArrowsClockwise />} />
      )}
    </Button>
  );
};

export default SendButtonEmail;
